import * as Sentry from '@sentry/vue'

const CHUNK_RELOAD_TS_KEY = '__chunk_reload_ts__'
const CHUNK_RELOAD_COOLDOWN_MS = 60_000

export function setupChunkReloadRecovery(): void {
  window.addEventListener('vite:preloadError', (event) => {
    let last = 0
    try {
      last = Number(sessionStorage.getItem(CHUNK_RELOAD_TS_KEY) ?? '0')
    } catch {
      // Storage blocked (e.g. iOS Safari private mode); Do nothing in this case.
      return
    }
    if (Date.now() - last < CHUNK_RELOAD_COOLDOWN_MS) {
      // We already log our own message here, so suppress Vite's rethrow to avoid double-reporting.
      event.preventDefault()
      Sentry.captureMessage('chunk preload errored again within reload cooldown', {
        level: 'error',
        extra: { sinceLastReloadMs: Date.now() - last },
      })
      return
    }
    try {
      sessionStorage.setItem(CHUNK_RELOAD_TS_KEY, Date.now().toString())
    } catch {
      // Storage blocked (e.g. iOS Safari private mode); Do nothing in this case.
      return
    }
    // Suppress Vite's rethrow so the error isn't reported to Sentry while we recover via reload.
    event.preventDefault()
    window.location.reload()
  })
}
